import React, { useEffect, useRef, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import moment from "moment";

// Assets
import "~/assets/sass/pages/common/settingPage/settingPage.scss";
import "~/assets/sass/pages/common/settingPage/Modal/settingModal.scss";

import EvalListModal from "./evaluateListModal/EvalListModal";
import DropdownList from "./components/DropdownList";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import Processing from "./processingModal/Processing";
import ProcessAlerts from "./processingModal/ProcessAlerts";
import lightInitImg from "~/assets/img/light-init-img.png";

import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";

const RoundSetting = () => {
	const [
		{
			sidebar: { currentPath },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	//----온라인 심사 평가 항목 모달 --------------------------------------------------
	const [evaluateCategoryModal, setEvaluateCategoryModal] = useState(false);
	//----수정 클릭시 모달 ------------------------------------------------------------
	const [roundItemModal, setRoundItemModal] = useState(false);

	//----심사항목 삭제 Alert 모달 ----------------------------------------------------
	const [deleteAlertModal, setDeleteAlertModal] = useState(false);
	const [noCategoryAlert, setNoCategoryAlert] = useState(false);
	const [weightingAlert, setWeightingAlert] = useState(false);
	const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
	const [noTitleAlert, setNoTitleAlert] = useState(false);
	const [noCategoryName, setNoCategoryName] = useState(false);
	const [noItemName, setNoItemName] = useState(false);
	const [settingList, setSettingList] = useState([]);
	const [settingDetail, setSettingDetail] = useState({});
	const [evalCategories, setEvalCategories] = useState([]);
	const [step, setStap] = useState("");

	const settingListRequest = useRequest("get", "/vc/round/setting/list");
	const settingDetailReqeust = useRequest("get", "/vc/round/setting/detail");
	const settingCreateRequest = useRequest("post", "/vc/round/setting/add");
	const settingModifyRequest = useRequest("post", "/vc/round/setting/edit");
	const settingDeleteRequest = useRequest("delete", "/vc/round/setting/delete");
	const [resetItemData, setResetData] = useState("");
	const [targetIdx, setTargetIdx] = useState("");

	const { t } = useTranslation();

	//----인피니트 스크롤 --------------------------------------------------------------
	// const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
	// const [page, setPage] = useState(1);
	// const [hasMore, setHasMore] = useState(false);

	//----신규 생성 --------------------------------------------------------------------
	const [createNew, setCreateNew] = useState("notCreate");
	// const lastElementRef = UseInfiniteScroll(pageState, page, setPage, hasMore);

	const [formData, setFormData] = useState({ page: 1, size: 100 });
	const ref = useRef();

	useEffect(() => {
		settingListRequest.call(formData);
	}, [formData]);

	// useEffect(() => {
	// 	setPageState(PAGE_STATE.LOADING);
	// 	settingListRequest.call(
	// 		{
	// 			size: 21,
	// 			page: 1,
	// 		}
	// 	);
	// // eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [page]);

	useEffect(() => {
		switch (settingListRequest.state) {
			case API_STATE.done:
				const resData = settingListRequest.response?.data.list;
				setSettingList(resData);
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [settingListRequest.state, settingListRequest.response, settingListRequest.error]);

	const deleteModalOpen = (idx) => {
		setTargetIdx(idx);
		setDeleteAlertModal(true);
	};

	const doDelete = (idx) => {
		settingDeleteRequest.call(idx, "path");
	};

	const modifyModalOpen = (idx) => {
		setCreateNew("notCreate");
		setTargetIdx(idx);
		setStap("process");
		settingDetailReqeust.call(idx, "path");
	};

	const handleNewCreation = (createFormData) => {
		settingCreateRequest.call(createFormData);
	};

	const handleModify = (modiFormData) => {
		settingModifyRequest.call(modiFormData);
	};

	const handleCreate = () => {
		setCreateNew("create");
		setRoundItemModal(true);
	};

	const handleSettingDetail = (idx) => {
		setCreateNew("notCreate");
		setStap("eval");
		settingDetailReqeust.call(idx, "path");
	};

	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => {
				if (currentPath.auth !== "edit") {
					showAuthAlert();
					return;
				}
				handleCreate();
			}}
		>
			{t("common.commonWord.button.add")}
		</button>,
	];

	useEffect(() => {
		switch (settingModifyRequest.state) {
			case API_STATE.done:
				setRoundItemModal(false);
				settingListRequest.call();
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingModifyRequest.state, settingModifyRequest.response, settingModifyRequest.error]);

	useEffect(() => {
		switch (settingDeleteRequest.state) {
			case API_STATE.done:
				setDeleteAlertModal(false);
				settingListRequest.call();
				break;
			case API_STATE.error:
				switch (settingDeleteRequest.error.statusCode) {
					case 404:
						alert(t("pages.round.RoundSetting.noExist"));
						setDeleteAlertModal(false);
						break;
					case 500:
						alert(t("pages.round.RoundSetting.retry"));
						setDeleteAlertModal(false);
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingDeleteRequest.state, settingDeleteRequest.response, settingDeleteRequest.error]);

	useEffect(() => {
		switch (settingCreateRequest.state) {
			case API_STATE.done:
				setRoundItemModal(false);
				settingListRequest.call();
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);

	useEffect(() => {
		switch (settingDetailReqeust.state) {
			case API_STATE.done:
				setSettingDetail(settingDetailReqeust.response?.data);
				setEvalCategories(settingDetailReqeust.response?.data?.Category);
				step === "eval"
					? setEvaluateCategoryModal(true)
					: step === "process"
					? setRoundItemModal(true)
					: alert(t("pages.round.RoundSetting.retryPlz"));
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingDetailReqeust.state, settingDetailReqeust.response, settingDetailReqeust.error]);

	return (
		<NavbarAndSidebarLayout menu={["round", "setting"]} type={"main"}>
			<PageHeader buttonList={headerButtons} />
			{/*<div className="pageIntro">*/}
			{/*	<JudgeSettingPageIcon />*/}
			{/*	<div className="content">*/}
			{/*		<h3>*/}
			{/*			<b>라운드 공지마다 평가항목을 설정해보세요.</b>*/}
			{/*		</h3>*/}
			{/*		<p>*/}
			{/*			빠르게 질의를 작성하고 각 라운드 공지마다 평가 항목과 답변을 체계적으로 관리해보세요.*/}
			{/*			<br />*/}
			{/*			매번 새로운 라운드 공지마다 새로운 평가 항목의 작성이 필요합니다.*/}
			{/*		</p>*/}
			{/*	</div>*/}
			{/*</div>*/}
			<div className="c__cardRow">
				{settingList.length > 0 ? (
					settingList.map((d) => {
						const itemLength = [];
						d.Category?.map((cat) => cat.Item?.map((iem) => itemLength.push(iem)));
						return (
							<div className="c__card" key={d.idx}>
								<DropdownList
									target={d.idx}
									{...{
										modifyModalOpen,
										deleteModalOpen,
										showAuthAlert,
										currentPath,
									}}
								/>
								<h3
									className="setting-title"
									onClick={() => handleSettingDetail(d.idx)}
								>
									{d.title}
								</h3>
								<div className="card-status">
									<span className="date">
										{moment(d.regDate).format("YYYY-MM-DD HH:mm:ss")}
									</span>
									<span className="item-number">{itemLength.length}</span>
								</div>
							</div>
							//---- Empty
							// <div className="page-init">
							// 	<p className="main">심사 항목을 추가해 주세요.</p>
							// 	<p className="sub">
							// 		심사 항목을 직접 만들고 심사를 진행하세요!
							// 	</p>
							// <img src={darkInitImg} alt="초기이미지" />
							// <img src={lightInitImg} alt="초기이미지" />
							// </div>
						);
					})
				) : (
					<div className="page-init">
						<p className="main">{t("pages.round.RoundSetting.addItem")}</p>
						<p className="sub">{t("pages.round.RoundSetting.createItem")}</p>
						<img src={lightInitImg} alt={t("pages.round.RoundSetting.initial")} />
					</div>
				)}
				<AuthAlert
					message={
						<>
							권한이 없습니다. <br />
							관리자에게 문의하세요.
						</>
					}
					type="warning"
					confirm="확인"
				/>
			</div>

			{/*카드 클릭시 온라인 심사 평가 항목 모달*/}
			<EvalListModal
				{...{
					settingDetail,
					evalCategories,
					evaluateCategoryModal,
					setEvaluateCategoryModal,
				}}
			/>

			<Processing
				{...{
					settingDetail,
					setSettingDetail,
					createNew,
					roundItemModal,
					setRoundItemModal,
					setNoCategoryAlert,
					setWeightingAlert,
					setNoEvaluationAlert,
					setNoTitleAlert,
					resetItemData,
					setResetData,
					setNoCategoryName,
					setNoItemName,
					handleModify,
					handleNewCreation,
					targetIdx,
				}}
			/>

			<ProcessAlerts
				{...{
					noCategoryAlert,
					setNoCategoryAlert,
					weightingAlert,
					setWeightingAlert,
					deleteAlertModal,
					setDeleteAlertModal,
					noEvaluationAlert,
					setNoEvaluationAlert,
					noTitleAlert,
					setNoTitleAlert,
					noCategoryName,
					setNoCategoryName,
					noItemName,
					setNoItemName,
					doDelete,
					targetIdx,
				}}
			/>
			<div ref={ref}></div>
		</NavbarAndSidebarLayout>
	);
};

export default RoundSetting;
